import React, { useState, useEffect } from 'react';
import Header from "../../Components/Layout/Header/Header";
import Footer from "../../Components/Layout/Footer/Footer";
import combinedServices from "../../shared/services/user-service";
import getLocalData from "../../shared/localStorage/getData";
import Pagination from "react-js-pagination";
import EventTab from "../../Components/EventTab/EventTab";
import { useParams } from "react-router-dom";



const Cancel = () => {
    const params = useParams();
   
 
   
    return (
        <>
            <div className="mainCon">
                <Header />
                <div className="innerBanner event">
                    <div className="container flexBox">
                        <div>
                            <div className="innerHd">Events</div>
                            <div className="bradcrumb"><a href="/">Home</a><a href="/event-management">Events</a></div>
                        </div>
                    </div>
                </div>

                
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mx-auto mt-5">
                            <div className="payment">
                                <div className="payment_header">
                                    <div className="check"><i class="checkmark">✓</i></div>
                                </div>
                                <div className="content">
                                    <h1>Payment Cancel !</h1>
                                    <p>Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. </p>
                                    <a href="/">Go to Home</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>

    )

}
export default Cancel;